import axios from 'axios'
import config from './config'

axios.defaults.baseURL = config.baseURL

function gettoken() {
	return localStorage.getItem('yjwltoken')
}

// 创建一个axios实例
const instance = axios.create({
	timeout: 300000,
	headers: {
		'Content-Type': 'application/json',
		'Authorization': 'Bearer ' + gettoken() // headers塞token
	}
})

instance.fileUrl = config.fileurl
instance.productID = config.productID

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = (token) => {
	instance.defaults.headers['Authorization'] = 'Bearer ' + token
	localStorage.setItem('yjwltoken', token)
}

instance.interceptors.response.use(response => {
	const {
		code
	} = response.data
	
	return response
}, error => {
	return Promise.reject(error)
})

export default instance